import { roleAdmin, roleManager, roleSuperAdmin } from '@/mixins/roles';

const OrganisationToursAttractions = () => import('@/pages/organisation-tours/attractions.vue');

export default [
  {
    path: '/organisation-tours/attractions',
    name: 'OrganisationToursAttractions',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Организованные туры',
        'Достопримечательности',
      ],
    },
    component: OrganisationToursAttractions,
  },
  {
    path: '/organisation-tours/attractions/:id',
    name: 'OrganisationToursAttractionsForm',
    meta: {
      auth: {
        roles: [roleAdmin, roleSuperAdmin, roleManager],
        forbiddenRedirect: '/forbidden',
      },
      title: [
        'Организованные туры',
        'Достопримечательности',
      ],
    },
    component: OrganisationToursAttractions,
  },
];
